import React from 'react';
import { JustWinPM2Layout } from 'Components/Modals/Investment/JustWinDialog/JustWinLayout/JustWinPM2Layout';
import { JustWinPM1Layout } from 'Components/Modals/Investment/JustWinDialog/JustWinLayout/JustWinPM1Layout';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

const LAYOUT_MAP = {
  JustWinPM1: JustWinPM1Layout,
  JustWinPM2: JustWinPM2Layout,
};

const JustWinLayoutPicker = () => {
  const { resource } = useMetaLayoutContext();
  const Layout = LAYOUT_MAP[resource?.type()];
  return <Layout />;
};

JustWinLayoutPicker.defaultProps = {};

JustWinLayoutPicker.propTypes = {};

export { JustWinLayoutPicker };
